import { useEffect, useRef, useState } from "react";
import "../../styles/CatalogTabs.css";

export default function CatalogCategoryTabs({
  visible = true,
  icon,
  items = [],
  activeId,
  onSelect,
}) {
  const scrollerRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({
    left: 0,
    width: 0,
  });

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;

    const activeEl = scroller.querySelector(".csTabBtn.isActive");
    if (!activeEl) return;

    const left = activeEl.offsetLeft;
    const width = activeEl.offsetWidth;

    setIndicatorStyle({ left, width });

    activeEl.scrollIntoView({
      behavior: "smooth",
      inline: "start",
      block: "nearest",
    });
  }, [activeId, items]);

  if (!visible || !items.length) return null;

  return (
    <div className="csTabsWrap">
      {icon ? (
        <button
          type="button"
          className="csTabIcon"
          onClick={() => onSelect?.(items[0])}
          aria-label="Catalog"
        >
          <img src={icon} alt="catalog" className="csTabIconImg" />
        </button>
      ) : null}

      <div className="csTabsScroller" ref={scrollerRef}>
        <div className="csTabs" role="tablist">
          {items.map((item) => {
            const isActive = String(activeId) === String(item.id);

            return (
              <button
                key={item.id}
                type="button"
                className={`csTabBtn ${isActive ? "isActive" : ""}`}
                onClick={() => onSelect?.(item)}
              >
                <span className="csTabLabel">{item.title}</span>
              </button>
            );
          })}

          <div
            className="csTabIndicator"
            style={{
              left: indicatorStyle.left,
              width: indicatorStyle.width,
            }}
          />
        </div>
      </div>
    </div>
  );
}